module.exports = __webpack_public_path__ + "img/6a3702e.png";